export default "__VITE_ASSET__DLoICti___"